import { API_URL } from "../config";
import { useAuth } from "../store/useAuth";

let refreshPromise: Promise<string | null> | null = null;

async function refreshAccessToken(): Promise<string | null> {
  const { user, updateTokens } = useAuth.getState();
  const currentRefreshToken = user?.refreshToken;

  if (!currentRefreshToken) return null;

  try {
    const res = await fetch(API_URL + "v1/auth/refresh", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refreshToken: currentRefreshToken }),
    });

    if (!res.ok) return null;

    const data = await res.json();
    updateTokens(data.accessToken, data.refreshToken);
    return data.accessToken;
  } catch {
    return null;
  }
}

export function getRefreshedToken(): Promise<string | null> {
  if (!refreshPromise) {
    refreshPromise = refreshAccessToken().finally(() => {
      refreshPromise = null;
    });
  }
  return refreshPromise;
}
